import script from "./fw03_ArticleLists.vue?vue&type=script&setup=true&lang=js"
export * from "./fw03_ArticleLists.vue?vue&type=script&setup=true&lang=js"

import "./fw03_ArticleLists.vue?vue&type=style&index=0&id=2579c5af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2579c5af"]])

export default __exports__